import { RootState } from "../Store";

export const SELECT_LIST_CLIENT_ACTIVE = (state: RootState) =>
  state.listClientSlice.LIST_CLIENT_ACTIVE;

export const SELECT_LIST_CLIENT_ARCHIVE = (state: RootState) =>
  state.listClientSlice.LIST_CLIENT_ARCHIVE;

export const SELECT_CLIENT = (state: RootState) =>
  state.listClientSlice.SELECTED_CLIENT;

export const SELECT_CLIENT_FORM_DISABLE = (state: RootState) =>
  state.listClientSlice.CLIENT_FORM.CLIENT_FORM_DISABLED;

export const SELECT_CLIENT_FROM_INITIAL = (state: RootState) =>
  state.listClientSlice.CLIENT_FORM.CLIENT_FORM_INITIAL;

export const SELECT_CLIENT_FORM_TYPE = (state: RootState) =>
  state.listClientSlice.CLIENT_FORM.CLIENT_FORM_TYPE;

export const SELECT_CLIENT_BY_ID =
  (id: number | undefined) => (state: RootState) => {
    if (id) {
      const findAgent = state.listClientSlice.LIST_CLIENT_ACTIVE.find(
        (client) => client.id === id
      );
      return findAgent;
    }
    return null;
  };
